/**
 * AppShell - Main layout wrapper for consistent header/footer across pages
 * Optimized for mobile with proper scrolling and touch handling
 * Header and footer are fixed, only content area scrolls
 */

import React, { ReactNode, useEffect } from 'react';
import AppHeader, { HeaderConfig } from './AppHeader';
import AppFooter from './AppFooter';
import './AppShell.css';

interface AppShellProps {
  children: ReactNode;
  headerConfig?: HeaderConfig;
  showFooter?: boolean;
  activeTab: string;
  onTabChange: (tab: string) => void;
  onMyVibeClick?: () => void;
}

const AppShell: React.FC<AppShellProps> = ({
  children,
  headerConfig,
  showFooter = true,
  activeTab,
  onTabChange,
  onMyVibeClick
}) => {
  // Prevent body scroll when AppShell is mounted
  useEffect(() => {
    // Add class to body for browsers that don't support :has()
    document.body.classList.add('app-shell-active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';

    return () => {
      // Cleanup on unmount
      document.body.classList.remove('app-shell-active');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, []);

  return (
    <div className="app-shell">
      {headerConfig && (
        <AppHeader config={headerConfig} />
      )}
      <main className="app-shell__content">
        {children}
      </main>
      {showFooter && (
        <AppFooter
          activeTab={activeTab}
          onTabChange={onTabChange}
          onMyVibeClick={onMyVibeClick}
        />
      )}
    </div>
  );
};

export default AppShell;
